export default __webpack_public_path__ + "static/media/truck_bg.b1b1b6ca.svg";